import {FAQS} from '../../../../Config/ApiUrl'
import {actionColumn, htmlColumn, textColumn} from "../../../../Helpers/TableCommonColumn";
import {createdFilter} from "../../../../Helpers/TableFIlter";
import {deleteAction, editAction} from "../../../../Helpers/TableAction";

export default {
    data() {
        return {
            options: {
                name: this.$t('faqs'),
                url: FAQS,
                showHeader: true,
                tableShadow: false,
                columns: [
                    textColumn(this.$t('question'), 'question'),
                    htmlColumn(this.$t('answer'), 'answer', (v) => v),
                    actionColumn(),
                ],
                showFilter: true,
                filters: [
                    createdFilter(),
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
                actions: [
                    editAction(this.$can('view_faqs'), FAQS),
                    deleteAction(this.$can('delete_faqs'), FAQS),
                ],
            }
        }
    },
}